export const WORKER_SIZE_LABELS: Record<string, string> = {
  xs: 'XS (0.5 CPU, 2 GiB)',
  small: 'Small (1 CPU, 4 GiB)',
  medium: 'Medium (2 CPU, 8 GiB)',
  large: 'Large (4 CPU, 16 GiB)',
  xl: 'XL (8 CPU, 32 GiB)',
};
